/** Per-session cache for background run ids (inject / subagent announce / spawn). */

type Store = Map<string, string[]>;

const stores = new WeakMap<object, Store>();

function storeFor(host: object): Store {
  const existing = stores.get(host);
  if (existing) {
    return existing;
  }
  const fresh: Store = new Map();
  stores.set(host, fresh);
  return fresh;
}

export function recordBackgroundRuns(
  host: object,
  sessionKey: string,
  runIds: Iterable<string>,
): void {
  const trimmed = sessionKey.trim();
  if (!trimmed) {
    return;
  }
  const ids = [...new Set([...runIds].map((id) => id.trim()).filter(Boolean))];
  if (ids.length === 0) {
    storeFor(host).delete(trimmed);
    return;
  }
  storeFor(host).set(trimmed, ids);
}

export function consumeBackgroundRuns(host: object, sessionKey: string): Set<string> {
  const trimmed = sessionKey.trim();
  if (!trimmed) {
    return new Set();
  }
  const store = storeFor(host);
  const ids = store.get(trimmed) ?? [];
  store.delete(trimmed);
  return new Set(ids);
}

export function clearBackgroundRuns(host: object, sessionKey: string): void {
  const trimmed = sessionKey.trim();
  if (!trimmed) {
    return;
  }
  storeFor(host).delete(trimmed);
}
